



































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import DefaultLayout from '../../layouts/DefaultLayout.vue';
import HeroBar from '@/components/base/HeroBar.vue';
import { Action, State } from 'vuex-class';
import {
  ProjectListPagePayload,
  GetProjectListPayload,
  ChangeProjectOwnerDTO,
} from '@/store/modules/projects/types/projects.types';
import { ToastProgrammatic as Toast } from 'buefy';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import BasePagination from '@/components/base/BasePagination.vue';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '@/utils/date.util';
import TableDropdown from '../AdminProjectManagement/components/TableDropdown.vue';
import ProjectOwnerRequestForm from './components/ProjectOwnerRequestForm.vue';
import {
  capitalizeFirstLetter,
  getJBIUsername,
} from '@/jbi-shared/util/user.utils';

@Component({
  components: {
    DefaultLayout,
    HeroBar,
    BasePagination,
    TableDropdown,
  },
})
export default class ProjectCreatedListPage extends Vue {
  @Prop() public participantProjectOnly!: boolean;
  @Prop() public userEmail!: string;
  @Prop() public isLoading!: boolean;
  public createdSearchQuery: string = '';
  public totalProjectActiveList: number = 0;
  public totalCount: number = 0;
  public perPage = 50;
  public page = 1;
  public createdProjectDetails: any = [];
  public isEmptyCreated: boolean = false;
  public dirtyLoading: boolean = false;

  @Action('projects/getCreatedProjects')
  public getCreatedProjects!: (params: GetProjectListPayload) => void;

  @State((state) => state.projects.createdListProject)
  public createdListProject!: ProjectListPagePayload[];

  get totalNumberOfPage(): number {
    return Math.ceil(this.totalCount / this.perPage);
  }

  get startItemIndex(): number {
    return this.page * this.perPage - this.perPage + 1;
  }

  get endItemIndex(): number {
    return Math.min(this.totalCount, this.page * this.perPage);
  }

  get isFirstPage(): boolean {
    return this.page === 1;
  }

  get isLastPage(): boolean {
    return this.page === this.totalNumberOfPage;
  }

  get getCurrentPage(): number {
    this.page = +this.$route.query.page || this.page;
    return this.page;
  }

  set getCurrentPage(newValue: number) {
    this.page = newValue;
    this.$router
      .push({
        path: this.$route.path,
        query: {
          tab: 'Created',
          search:
            (this.$route.query.search as string) || this.createdSearchQuery,
          limit: (this.$route.query.limit as string) || this.perPage.toString(),
          page: this.page.toString(),
        },
      })
      .catch(() => {
        return;
      });
    this.getCreatedProjects({
      search: this.createdSearchQuery,
      limit: this.perPage,
      page: this.page,
      participantProjectOnly: this.participantProjectOnly,
    });
  }

  get getCurrentPerPage(): number {
    this.perPage = +this.$route.query.limit || this.perPage;
    return this.perPage;
  }

  set getCurrentPerPage(newValue: number) {
    this.perPage = newValue;
    this.$router
      .push({
        path: this.$route.path,
        query: {
          tab: 'Created',
          search:
            (this.$route.query.search as string) || this.createdSearchQuery,
          limit: this.perPage.toString(),
          page: (this.$route.query.page as string) || this.page.toString(),
        },
      })
      .catch(() => {
        return;
      });
    this.getCreatedProjects({
      search: this.createdSearchQuery,
      limit: this.perPage,
      page: this.page,
      participantProjectOnly: this.participantProjectOnly,
    });
  }

  public mounted() {
    this.dirtyLoading = this.isLoading;
    this.createdSearchQuery = (this.$route.query.search as string) || '';
    if (this.createdSearchQuery) {
      this.$router
        .push({
          path: this.$route.path,
          query: {
            tab: 'Created',
            search:
              (this.$route.query.search as string) || this.createdSearchQuery,
            limit:
              (this.$route.query.limit as string) || this.perPage.toString(),
            page: (this.$route.query.page as string) || this.page.toString(),
          },
        })
        .catch(() => {
          return;
        });
    }
    this.getCreatedProjects({
      search: (this.$route.query.search as string) || this.createdSearchQuery,
      limit: Number(this.$route.query.limit) || this.perPage,
      page: Number(this.$route.query.page) || this.page,
      participantProjectOnly: this.participantProjectOnly,
    });
  }

  public formatDate(s: string) {
    return dayjs(s).format(DATE_FORMAT);
  }

  public truncateAdministratorName(item: any, isNameLonger: boolean) {
    const administratorName = item.administratorName.slice(
      0,
      -(item.user.email.length + 3),
    );
    if (isNameLonger) {
      return `${administratorName.substring(0, 35)} ...`;
    } else {
      return `${item.user.email.substring(
        0,
        35 - administratorName.length,
      )} ...`;
    }
  }

  public getAdministratorName(item: any) {
    const givenName = capitalizeFirstLetter(item.user.oicPayload.given_name);
    const familyName = capitalizeFirstLetter(item.user.oicPayload.family_name);
    item.administratorName = `${givenName} ${familyName} (${item.user.email})`;
    item.given_name = givenName;
    item.family_name = familyName;
    return item;
  }

  public getProjectUrl(item: any) {
    const projectUrl = '/projects/' + item.id + '#dashboard';
    if (item.originator.email === this.userEmail) {
      return projectUrl;
    }
  }

  public async handleReclaimProjectOwnership(item: any) {
    this.$buefy.modal.open({
      parent: this,
      props: {
        projectId: item.id,
        projectOwnerEmail: item.user.email,
        projectOwnerName: getJBIUsername(item.user.email, item.user.oicPayload),
        isSystemAdmin: false,
        isReclaimProjectOwnership: true,
      },
      events: {
        confirm: async (changeProjectOwnerDTO: ChangeProjectOwnerDTO) => {
          Toast.open({
            message: `Request project ownership sent to ${changeProjectOwnerDTO.currentProjectOwnerEmail}`,
            position: 'is-top',
            type: 'is-dark',
            duration: 3500,
          });
        },
      },
      component: ProjectOwnerRequestForm,
      hasModalCard: true,
    });
  }

  @isTruthy
  @Watch('createdListProject')
  public getWatcherActiveListProject(newValue: any) {
    this.dirtyLoading = false;
    this.$emit('updateLoadingBool', this.dirtyLoading);
    this.createdProjectDetails = [];
    if (newValue.items.length > 0) {
      newValue.items.map((dirtyProjectItem: ProjectListPagePayload) => {
        const newProjectItem = this.getAdministratorName(dirtyProjectItem);
        this.createdProjectDetails.push(newProjectItem);
      });
      this.isEmptyCreated = false;
    } else {
      this.isEmptyCreated = true;
    }
    this.totalCount = newValue.totalItems;
  }

  @Watch('createdSearchQuery')
  public watchCreatedSearchQuery(newValue: string) {
    this.page = 1;
    this.$router
      .push({
        path: this.$route.path,
        query: {
          tab: 'Created',
          search: newValue,
          limit: this.perPage.toString(),
          page: this.page.toString(),
        },
      })
      .catch(() => {
        return;
      });
    this.getCreatedProjects({
      search: newValue,
      limit: this.perPage,
      page: this.page,
      participantProjectOnly: this.participantProjectOnly,
    });
  }

  @Watch('$route.query.tab')
  public routeParam() {
    if (this.$route.query.tab === 'Created') {
      this.$router
        .push({
          path: this.$route.path,
          query: {
            tab: 'Created',
            search: this.createdSearchQuery,
            limit: this.perPage.toString(),
            page: this.page.toString(),
          },
        })
        .catch(() => {
          return;
        });
      const params = {
        search: this.createdSearchQuery,
        limit: this.perPage,
        page: this.page,
        participantProjectOnly: this.participantProjectOnly,
      };

      return this.getCreatedProjects(params);
    }
  }
}
